var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "preloader",
    class: { visible: _vm.visible },
    style: { transform: "scaleX(" + _vm.percentage / 100.0 + ")" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }